import PropTypes from 'prop-types';
import React from 'react';
import CriteriaRowWrapper from '../CriteriaRowWrapper';
import { ComparisionToggle } from 'Components/Inputs/ComparisonTypeToggle';
import { SelectTokens } from '@upsales/components';
import T from 'Components/Helpers/translate';
import _ from 'lodash';

export default class TextInput extends React.Component {
	constructor(props) {
		super(props);

		this.lang = {
			trueText: T(this.props.config.inputTrueText || 'comparison.Equals'),
			falseText: T(this.props.config.inputFalseText || 'comparison.NotEquals')
		};

		this.onValuesChange = this.onChange.bind(this, 'values');
		this.onComperatorChange = this.onChange.bind(this, 'comperator');
	}


	onChange(key, value) {
		const { filter, onChange } = this.props;
		const newFilter = _.cloneDeep(filter);

		switch (key) {
			case 'values':
				newFilter.value = value;
				break;
			case 'comperator':
				newFilter.comparisonType = value;
				break;
		}

		newFilter.inactive = !this.isFilterActive(newFilter);

		onChange(newFilter.value, newFilter);
	}

	getPlaceholder() {
		const { config } = this.props;

		if (config.filterName.indexOf('Custom') > -1) {
			return T('default.freeText');
		}

		switch (config.filterName) {
			case 'NameList':
			case 'EmailList':
			case 'NotesList':
			case 'NameClientList':
			case 'Address':
				return T('segment.placeholder.' + config.filterName);
			case 'Name':
				return T('segment.placeholder.NameList');
			default:
				return T('segment.selectCriteriaPlaceholder');
		}
	}



	isFilterActive(filter) {
		return Array.isArray(filter.value) && filter.value.length ? true : false;
	}

	render() {
		const { filter } = this.props;
		// Legacy segments stored String custom-field values as a scalar (e.g. "north").
		// Segments now treat these as token lists, so coerce any scalar into a single-item array.
		const values = Array.isArray(filter.value)
			? filter.value
			: filter.value == null || filter.value === ''
			? []
			: [filter.value];
		const classNames = values.length ? 'multi-comparitors-wrap active' : 'multi-comparitors-wrap';

		return (
			<CriteriaRowWrapper>
				<div className="criteria-row">
					<div className={classNames}>
						<ComparisionToggle
							trueValue={this.props.trueValue}
							falseValue={this.props.falseValue}
							trueText={this.lang.trueText}
							falseText={this.lang.falseText}
							onClick={this.onComperatorChange}
							value={filter.comparisonType}
						/>
						<SelectTokens
							value={values.map(id => ({ id }))}
							onChange={val => this.onValuesChange(val.map(v => v.id))}
							placeholder={this.props.placeholder || this.getPlaceholder()}
						/>
					</div>
				</div>
			</CriteriaRowWrapper>
		);
	}
}

TextInput.propTypes = {
	name: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	filter: PropTypes.object.isRequired,
	config: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	className: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	tabIndex: PropTypes.number,
	autoFocus: PropTypes.bool,
	trueValue: PropTypes.string,
	falseValue: PropTypes.string
};

TextInput.defaultProps = {
	autoFocus: true,
	trueValue: 'Search',
	falseValue: 'NotSearch'
};
